<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md6 lg4>
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title>Login form</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    prepend-icon="person"
                    name="login"
                    label="Login"
                    type="text"
                    v-model="username"
                  ></v-text-field>
                  <v-text-field
                    id="password"
                    prepend-icon="lock"
                    name="password"
                    label="Password"
                    type="password"
                    v-model="password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="onClick">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-loading :dialog="isLoading" />
  </v-app>
</template>

<script>
// @ is an alias to /src
// import global from "@/components/global";
import loginService from "@/services/admin/authorization";
import { log } from "util";
import { userInfo } from "os";
export default {
  name: "home",
  components: {
    // ...global
  },
  data() {
    return {
      isLoading: false,
      username: "",
      password: ""
    };
  },
  methods: {
    onClick() {
      this.isLoading = true;
      loginService
        .login(this.username, this.password)
        .then(x => {
          console.log("Here");
          this.isLoading = false;

          this.$router.push({ name: "groups" });
        })
        .catch(err => {
          this.isLoading = false;

          console.log(err);
        });
    },
    onSubmit(evt) {
      evt.preventDefault();
    }
  },
  created() {
    loginService.isAlive().then(data => {
      if (Boolean(data) == true) {
        console.log("Good!");
        this.$router.push({ name: "dashboard" });
      } else {
        console.log("False!");
      }
    });
  }
};
</script>
<style scoped>
</style>

